import { Button, Divider, Grid, Stack } from "@mui/material";
import { NavLink } from "react-router-dom";
import ResultPageIntro from "./ResultPageIntro";
import DashboardView from "../DashboardPage/DashboardView";
import { Project } from "../../../types/project";

type ResultPageProps = {
  project: Project;
};

export default function ResultPage({ project }: ResultPageProps) {
  return (
    <Grid container mt={2} flexDirection={"column"}>
      <Grid item xs mb={4}>
        <Grid container mb={2}>
          <Grid item xs>
            <Grid container>
              <Grid item lg={4} />
              <Grid item lg={6}>
                <ResultPageIntro />
              </Grid>
            </Grid>
          </Grid>
          <Divider orientation="vertical" flexItem />
          <Grid item xs>
            <Grid container>
              <Grid item lg={2} />
              <Grid item lg={4}>
                <Stack direction={"column"}>
                  <Button
                    component={NavLink}
                    to={"/create-project"}
                    variant={"contained"}
                  >
                    Create new project?
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider />
      <Grid item xs mt={4}>
        <DashboardView pc={project.projectCode} hideBackBtn={true} />
      </Grid>
    </Grid>
  );
}
